import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { Briefcase, Calculator, Building2, FileText, Target, Heart } from 'lucide-react';

const ServicesSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const icons = [Briefcase, Calculator, Building2, Target, Heart];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-navy-900 mb-4">{t.services.title}</h2>
          <p className="text-xl text-gold-600 font-medium">{t.services.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.services.items.map((service, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-cream-50 border border-gray-200 rounded-xl p-8 hover:shadow-2xl hover:border-gold-300 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="mb-6">
                  <div className="inline-flex p-4 bg-navy-700 group-hover:bg-gold-600 rounded-xl transition-colors duration-300">
                    <Icon className="text-white" size={32} />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-navy-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;